import styled from 'styled-components';
import { StyledUiContainerProps } from 'components';
import breakpoint from 'constants/breakpoints';

interface Props extends StyledUiContainerProps {
  image?: string;
}

const spacer = '3em';

export const MachineOverviewWidgetContainer = styled.div<Props>`
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  display: grid;
  gap: ${spacer};
  padding: 0.5em ${spacer};
  align-items: center;
  justify-content: center;
  min-height: 250px;
  overflow: hidden;
  padding: 0.25em 2em;

  @media (min-width: ${breakpoint.size.md}px) {
      grid-template-columns: 200px 1fr;
      padding: 0.5em 0.2em;
  }

  @media (min-width: ${breakpoint.size.md}px) {
      grid-template-columns: 200px 1fr;
      padding: 0.5em 0.5em;
  }

  @media (min-width: ${breakpoint.size.lg}px) {
      grid-template-columns: 30% 1fr;
      padding: 0.5em 3em;
  }

  .machine-overview-widget__image {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    background-image: url(${({ image }) => image}) center center no-repeat contain;

    img {
      width: 100%;
      max-width: 350px;
    }
  }

  .machine-overview-widget__tiles {
    display: flex;
    flex-direction: column;
    min-height: 250px;
    justify-content: space-between;
    height: 100%;
    padding-left: 3em;
    margin: 0 auto;
    width: 100%;

    @media (min-width: ${breakpoint.size.md}px) {
      width: auto;
    }

    &.aseptic-widget{
      min-height: 350px !important;
    }

    .container--table {
      min-height: 130px;
    }
  }

  .machine-overview-widget__tile {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    &.aseptic-widget {
      border-bottom: none !important;
    }

    position: relative;
    width: 100%;
    flex-grow: 1;
    height: 100%;
    display: flex;
    align-items: center;

    &:last-of-type {
      border-bottom: none;
    }
  }

  .widget-tile__inner {
    display: grid;
    position: relative;
    grid-template-columns: 5em 1fr;
    flex-grow: 0;

    .widget-tile__cell--icon {
      position: absolute;
      width: 2.5em;
      height: 2.5em;
      left: -3em;
      //transform: translateX(-100%);
      top: -5px;
    }
  }

  .widget-header {
    font-weight: 600;
    color: #666666;
    border-bottom: 1px solid rgb(229, 233, 237);
    padding-bottom: 1px;
    font-size: 0.875em;
    margin: 0px 0px 5px -52px;
  }
`;

export const WigetTileCellContainer = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: column;

  &.widget-tile__cell--icon {
    width: 3em;
    height: 3em;
    margin-right: 1em;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 50%;
      height: 50%;

      path {
        stroke: white;
      }
    }

    &.aseptic-widget svg {
      width: unset;
      height: unset;
    }

    span {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      border-radius: 50%;

      background-color: ${({ color }) => color};
    }
  }

  &.widget-tile__cell--title {
    font-weight: 600;
    font-size: 0.925em;
    text-transform: capitalize;
    box-sizing: content-box;
  }

  &.widget-tile__cell--value {
    padding-left: 1.5em;
   
    &.aseptic-widget{
      text-align: right !important;
    }

    .widget-tile__value {
      font-size: 1.3em;
      
      &.aseptic-widget{
        font-size: 1.2em;!important;
      }
        
      line-height: 1;
      align-items: left;
      text-transform: capitalize;
      font-weight: 600;
      width: 160px;

      color: ${({ color }) => color};

      span {
        color: rgba(0, 0, 0, 0.7);
      }
    }

    .widget-tile__sub-value {
      padding-top: 0.25em;
      text-transform: capitalize;
      font-size: 0.9em;
      color: #666666;
    }

    .widget-tile__label {
      padding-bottom: 0.25em;
      font-size: 0.8em;
      color: #666666;
      text-transform: capitalize;
    }
  }

  &.is-last {
    border-bottom: none;
  }
`;

export const ChangeOverWidgetContainer = styled.div`
    //min-height: 165px;
    //margin-left: -91px;
  }
  `;
export const ChangeOverSummary = styled.div`
  padding-left: 2rem;
`;
